import { http } from '@admin-base/core'

const prefix = '/'

// 教材版本列表
const versionList = data => {
    return http.post(prefix + 'api/resource/textbook/version/list', data)
}

// 教材列表
const textbookList = data => {
    return http.post(prefix + 'api/resource/textbook/list', data)
}

// 单元章节列表
const unitList = data => {
    return http.post(prefix + 'api/resource/textbook/chapter/list', data)
}

export {
    versionList,
    textbookList,
    unitList
}
